import * as React from "react";


export default function VitalsRulesPage() {
  return (
   <h1>VitalsRulesPage</h1>
  );
}